/**
 * Mega Menu Slider Web Component
 * Initializes Swiper slider for mega menu product carousel
 */
class MegaMenuSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  initSwiper() {
    if (this.swiper) return;
    if (!window.Swiper) {
      document.addEventListener('mma:swiper-ready', () => this.initSwiper(), { once: true });
      return;
    }

    const swiperEl = this.querySelector('.mega-menu-swiper');
    if (!swiperEl) return;

    const nextButton = this.querySelector('.mega-menu-swiper-button-next');
    const prevButton = this.querySelector('.mega-menu-swiper-button-prev');
    const paginationEl = this.querySelector('.mega-menu-swiper-pagination');

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 1.5,
      spaceBetween: 8,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      pagination: {
        el: paginationEl,
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
          pagination: {
            enabled: false,
          },
        },
      },
    });
  }
}

customElements.define('mega-menu-slider', MegaMenuSlider);

